import BaseService from './base'

export default class LanguageService extends BaseService {
  static resource() {
    return 'api/v1/languages'
  }
}
